
import { useState, useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import NewsLayout from '../../components/feature/NewsLayout';

interface Article {
  id: string;
  title: string;
  content: string;
  category: string;
  excerpt: string;
  image_url: string;
  author: string;
  published_at: string;
  tags: string[];
  view_count: number;
}

export default function BaziPage() {
  const [articles, setArticles] = useState<Article[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchBaziArticles();
  }, []);

  const fetchBaziArticles = async () => {
    try {
      const response = await fetch(
        `${import.meta.env.VITE_PUBLIC_SUPABASE_URL}/functions/v1/get-articles?category=八字算命&limit=50`,
        {
          headers: {
            'Authorization': `Bearer ${import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY}`,
          },
        }
      );
      
      if (response.ok) {
        const data = await response.json();
        setArticles(data.articles || []);
      }
    } catch (error) {
      console.error('獲取八字文章失敗:', error);
      setArticles(getDefaultBaziArticles());
    } finally {
      setLoading(false);
    }
  };

  const getDefaultBaziArticles = () => [
    {
      id: 'bazi1',
      title: '八字命理解析：從出生時間看一生運勢軌跡',
      excerpt: '透過八字命理學，深入分析個人的天干地支組合，預測一生的運勢起伏與發展軌跡，為人生規劃提供重要參考...',
      published_at: '2024-01-15T09:15:00Z',
      category: '八字算命',
      image_url: 'https://public.readdy.ai/ai/img_res/e139290269e77dfcda9fcea8c90ab2c1.jpg',
      author: '命理大師 王老師',
      content: '',
      tags: ['八字', '命理', '運勢'],
      view_count: 2234
    },
    {
      id: 'bazi2',
      title: '十神分析完全指南：了解你的性格與天賦密碼',
      excerpt: '八字中的十神代表不同的性格特質和能力傾向，學會分析十神可以更好地認識自己，發揮天賦潛能...',
      published_at: '2024-01-14T16:30:00Z',
      category: '八字算命',
      image_url: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20divination%20symbols%20and%20characters%2C%20traditional%20fortune%20telling%20setup%20with%20incense%20and%20scrolls%2C%20golden%20lighting%2C%20mystical%20oriental%20atmosphere&width=400&height=250&seq=bazi2&orientation=landscape',
      author: '命理大師 王老師',
      content: '',
      tags: ['八字', '十神', '性格'],
      view_count: 1889
    },
    {
      id: 'bazi3',
      title: '大運流年分析：把握人生重要轉折點',
      excerpt: '通過大運和流年的分析，預測人生各個階段的運勢變化，提前做好規劃和準備，化解不利因素...',
      published_at: '2024-01-13T13:45:00Z',
      category: '八字算命',
      image_url: 'https://readdy.ai/api/search-image?query=Chinese%20calendar%20and%20fortune%20telling%20charts%2C%20traditional%20wooden%20desk%20with%20ancient%20texts%2C%20warm%20candlelight%2C%20scholarly%20atmosphere%20with%20feng%20shui%20elements&width=400&height=250&seq=bazi3&orientation=landscape',
      author: '命理大師 王老師',
      content: '',
      tags: ['八字', '大運', '流年'],
      view_count: 1567
    },
    {
      id: 'bazi4',
      title: '五行相生相剋：平衡命局的智慧',
      excerpt: '五行理論是八字命理的核心，了解五行相生相剋的規律，學會調和命局，改善運勢...',
      published_at: '2024-01-12T10:20:00Z',
      category: '八字算命',
      image_url: 'https://readdy.ai/api/search-image?query=Five%20elements%20symbols%20in%20traditional%20Chinese%20style%2C%20wood%20fire%20earth%20metal%20water%2C%20circular%20arrangement%20with%20ancient%20Chinese%20aesthetics%2C%20harmonious%20colors&width=400&height=250&seq=bazi4&orientation=landscape',
      author: '命理大師 王老師',
      content: '',
      tags: ['八字', '五行', '平衡'],
      view_count: 1345
    },
    {
      id: 'bazi5',
      title: '八字合婚指南：找到命中註定的另一半',
      excerpt: '通過八字合婚分析兩人的命理相配程度，了解感情發展的可能性，為婚姻選擇提供參考...',
      published_at: '2024-01-11T14:10:00Z',
      category: '八字算命',
      image_url: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20wedding%20fortune%20telling%2C%20red%20and%20gold%20decorations%2C%20ancient%20marriage%20compatibility%20charts%2C%20romantic%20atmosphere%20with%20traditional%20elements&width=400&height=250&seq=bazi5&orientation=landscape',
      author: '命理大師 王老師',
      content: '',
      tags: ['八字', '合婚', '婚姻'],
      view_count: 2156
    },
    {
      id: 'bazi6',
      title: '八字改運法：化解命理不利因素',
      excerpt: '學會運用風水、姓名、顏色等方法調整運勢，化解八字中的不利因素，提升人生運程...',
      published_at: '2024-01-10T11:55:00Z',
      category: '八字算命',
      image_url: 'https://readdy.ai/api/search-image?query=Chinese%20feng%20shui%20and%20fortune%20improvement%20methods%2C%20crystals%20and%20traditional%20ornaments%2C%20peaceful%20meditation%20space%2C%20positive%20energy%20atmosphere&width=400&height=250&seq=bazi6&orientation=landscape',
      author: '命理大師 王老師',
      content: '',
      tags: ['八字', '改運', '風水'],
      view_count: 1678
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <NewsLayout 
        articles={articles}
        loading={loading}
        category="八字算命"
        categoryColor="bg-red-600"
      />
      <Footer />
    </div>
  );
}
